<div class="modal check-account-balance-modal">
  <div class="container model-container" [class.top-up-mode]="showTopUpCard">
    <div class="modal-header">
      <h4 class="modal-heading" *ngIf="!showTopUpCard" translate>check-account-balance-modal.title</h4>
      <img src="assets/icon/primary-close.svg" (click)="closeDialog()" class="modal-close" width="28" height="28"
        alt="Close Icon">
    </div>
    <div class="modal-body" *ngIf="!showTopUpCard">
      <div class="modal-content">
        <p class="first-description" translate>check-account-balance-modal.description</p>
        <p translate>check-account-balance-modal.charge-note</p>
        <div class="modal-actions">
          <button class="button primary" (click)="topUpBalance()" translate>
            check-account-balance-modal.top-up
          </button>
          <button class="button secondary" (click)="gotEnoughBalance()" translate>
            check-account-balance-modal.got-enough
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="showTopUpCard">
      <app-top-up-card [planId]="data.plan?.id" [verificationRequired]="true"></app-top-up-card>
    </div>
  </div>
</div>
